import { useState } from 'react';
import coachStaffService from '../../../services/coachStaffService';

export const AddStaffModal = ({ onClose, onSuccess }) => {
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '' });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!form.firstName.trim() || !form.lastName.trim() || !form.email.trim()) {
      setError('Please fill in all fields.');
      return;
    }

    setSubmitting(true);
    try {
      // jobTitle is fixed to "coach" inside the service
      const data = await coachStaffService.addStaff({
        firstName: form.firstName.trim(),
        lastName: form.lastName.trim(),
        email: form.email.trim(),
      });
      onSuccess(data);
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to add staff. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
      <div className="bg-jp-section border border-jp-line rounded-2xl w-full max-w-md p-6 sm:p-8 relative">
        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-jp-muted hover:text-jp-ink transition-colors"
          aria-label="Close"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <h3 className="text-2xl font-anton text-jp-ink tracking-wide mb-1">CREATE STAFF</h3>
        <p className="text-jp-muted text-sm font-roboto mb-6">
          Login credentials will be sent to the staff member via email.
        </p>

        {error && (
          <div className="bg-red-500/20 border border-red-500 text-red-200 px-4 py-3 rounded-xl text-sm font-roboto mb-5">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-left text-jp-ink text-sm font-roboto mb-2">First name</label>
              <input
                type="text"
                value={form.firstName}
                onChange={handleChange('firstName')}
                placeholder="Vikrant"
                className="w-full px-4 py-3 rounded-xl bg-jp-field border border-jp-line text-jp-ink placeholder-jp-muted/70 focus:outline-none focus:ring-2 focus:ring-jp-accent/40 transition-all font-roboto"
              />
            </div>
            <div>
              <label className="block text-left text-jp-ink text-sm font-roboto mb-2">Last name</label>
              <input
                type="text"
                value={form.lastName}
                onChange={handleChange('lastName')}
                placeholder="B"
                className="w-full px-4 py-3 rounded-xl bg-jp-field border border-jp-line text-jp-ink placeholder-jp-muted/70 focus:outline-none focus:ring-2 focus:ring-jp-accent/40 transition-all font-roboto"
              />
            </div>
          </div>

          <div>
            <label className="block text-left text-jp-ink text-sm font-roboto mb-2">Email</label>
            <input
              type="email"
              value={form.email}
              onChange={handleChange('email')}
              placeholder="vikrant.b@example.com"
              className="w-full px-4 py-3 rounded-xl bg-jp-field border border-jp-line text-jp-ink placeholder-jp-muted/70 focus:outline-none focus:ring-2 focus:ring-jp-accent/40 transition-all font-roboto"
            />
          </div>

          {/* Job title is fixed */}
          <div>
            <label className="block text-left text-jp-ink text-sm font-roboto mb-2">Job title</label>
            <input
              type="text"
              value="Coach"
              disabled
              className="w-full px-4 py-3 rounded-xl bg-jp-section border border-jp-line text-jp-muted cursor-not-allowed font-roboto"
            />
          </div>

          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              disabled={submitting}
              className="flex-1 py-3 rounded-xl border border-jp-line text-jp-ink font-roboto text-sm hover:bg-jp-line transition-all disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="flex-1 py-3 rounded-xl bg-cyan-400 text-slate-900 font-medium font-roboto text-sm hover:bg-cyan-300 transition-all disabled:opacity-50"
            >
              {submitting ? 'Creating...' : 'Create Staff'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddStaffModal;
